/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meta_DescInputs */

const en_tut_meta_desc = /** @type {(inputs: Tut_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn Bystep step by step: plan from a PRD, brief or codebase, build with your team using personal AI tools, share tasks and reviews, or use agent teams, CLI, MCP and Desktop.`)
};

const id_tut_meta_desc = /** @type {(inputs: Tut_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari Bystep langkah demi langkah: mulai dari PRD, brief, atau codebase, build bersama tim memakai AI masing-masing, bagikan tugas dan review, atau gunakan tim agent, CLI, MCP, dan Desktop.`)
};

/**
* | output |
* | --- |
* | "Learn Bystep step by step: plan from a PRD, brief or codebase, build with your team using personal AI tools, share tasks and reviews, or use agent teams, CLI..." |
*
* @param {Tut_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meta_desc = /** @type {((inputs?: Tut_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meta_desc(inputs)
	return en_tut_meta_desc(inputs)
});